import axiosServices from "../utils/axios"

import type { BunkerFreshWaterDetail } from "../utils/types/bunkerFreshWater"

interface BunkerFreshWaterApiResponse{
    data:BunkerFreshWaterDetail;
}

export const fetchBunkerFreshWaterDetail=async(bunkers_fresh_water_id: string)=>{
    const response=await axiosServices.get<BunkerFreshWaterApiResponse>(`/bunkersfreshwater/${bunkers_fresh_water_id}`)
    return response.data
}